import {useAppSelector} from "../storage/hooks";
import {selectApps, selectTrendingApps} from "../storage/slicers/appSlice";
import {Row} from "react-bootstrap";
import Card from "./Card";
import {APP} from "../storage/constants/properties";
import {AppCardType} from "../storage/types/state_types";

function TrendingApps() {
    const apps = useAppSelector(selectApps);
    const array = useAppSelector(selectTrendingApps);
    const trending_apps = array.map((id) => apps.find((a: AppCardType) => a.id === id));

    return(
        <Row>
            {trending_apps.map((app: any) => (
                <Card id={app.id} type={APP}/>
            ))}
        </Row>
    );
}

export default TrendingApps;